const leathersGrouped = {
  
  CineSuede: {
    leatherPrice: '',
    tooltip:
      `An extremely soft, high quality suede-textured fabric that provides a warm and cozy, true-to-theater cinematic experience.`,
    sampleImage: require('../img/cinesuede.png'),
    overwriteChannels: (channels, linearColor, replaceTexture = true) => {
      if(!channels) return channels;
      const normalTexture = (window.api.textures.filter((t) => t.name === 'cinesuede_normal.jpg') || [])[0]
      // const bumpTexture = (window.api.textures.filter((t) => t.name === 'leather_diff_levels.jpg') || [])[0]
      const metalnessTexture = (window.api.textures.filter((t) => t.name === 'leather_diff_levels.jpg') || [])[0]

      if (replaceTexture) {
        if (normalTexture) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: normalTexture.uid }
        }
      }
      // if (bumpTexture) {
      //   channels.BumpMap.texture = { ...(channels.BumpMap.texture || {}), uid: bumpTexture.uid }
      // }
      if (metalnessTexture) {
        channels.MetalnessPBR.texture = { ...(channels.MetalnessPBR.texture || {}), uid: metalnessTexture.uid }
      }
      channels.SpecularF0.factor = 0.6
      channels.RoughnessPBR.factor = 0.85
      // channels.BumpMap.enable = true
      channels.CavityPBR.enable = false
      channels.NormalMap.enable = true
      channels.MetalnessPBR.enable = true
      channels.MetalnessPBR.factor = 0.38

      channels.AlbedoPBR.color = linearColor
      channels.DiffusePBR.color = linearColor
      channels.DiffuseColor.color = linearColor

      return channels
    },
    colors: {
      'Oyster': '#c3beab',
      'Camel': '#543c18',
      'Dark Chocolate': '#21120d',
      'Royal Blue': '#060d4c',
      // 'Steel': '#636962',
      'Jet Black': '#0e0e0e',
      // 'Deep Purple': '#1a1b2d',
      'Theater Red': '#7b0015',
      Taupe: '#867058',
      Platinum: '#aca497',
    },
  },
  'Tottori Leather': {
    leatherPrice: `+$500 per chair`,
    tooltip:
      'Tottori Leather has the visual and spill resistant qualities of leather with a classic pebbled texture, matte aesthetic, and authentic softness, in an animal-free leather alternative.',
    sampleImage: require('../img/tottori.png'),
    overwriteChannels: (channels, linearColor, replaceTexture = true) => {
      
      if(!channels) return channels;
      const normalTexture = (window.api.textures.filter((t) => t.name === 'silk_leather_normal.jpg') || [])[0]
      const cavityTexture = (window.api.textures.filter((t) => t.name === 'silk_leather_cavity.jpg') || [])[0]

      if (replaceTexture) {
        if (normalTexture) {
          channels.NormalMap.texture = { ...(channels.NormalMap.texture || {}), uid: normalTexture.uid }
        }
      }
      if (cavityTexture) {
        channels.CavityPBR.texture = { ...(channels.CavityPBR.texture || {}), uid: cavityTexture.uid }
      }
      channels.SpecularF0.factor = 0.2
      channels.RoughnessPBR.factor = 0.6
      channels.BumpMap.enable = false
      channels.NormalMap.enable = true
      channels.CavityPBR.enable = true
      channels.MetalnessPBR.enable = false

      channels.AlbedoPBR.color = linearColor
      channels.DiffusePBR.color = linearColor
      channels.DiffuseColor.color = linearColor

      return channels
    },
    colors: {
      'Rice Paper': '#a8a596',
      'Udon': '#cac3a6',
      'Sand Castle': '#6c6960',
      'Black Sesame': '#22231e',
      'Desert Dune': '#625646',
      'Rouge': '#682421',
      'Terrain': '#5d422f',
      'Hot Spring': '#38454e',
    },
  },
}

const leathers = Object.keys(leathersGrouped).map((leatherName) =>
  Object.keys(leathersGrouped[leatherName].colors).map((colorName) => ({
    leatherName,
    colorName,
    leatherPrice:  leathersGrouped[leatherName].leatherPrice,
    hex: leathersGrouped[leatherName].colors[colorName],
    overwriteChannels: leathersGrouped[leatherName].overwriteChannels,
    sampleImageUrl: leathersGrouped[leatherName].sampleImage,
    tooltip: leathersGrouped[leatherName].tooltip,
  }))
)

// console.log(leathers)

export default leathers
